
<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24"><path d="M15 20H9v-8H4.16L12 4.16L19.84 12H15v8z" fill="currentColor"></path></svg>
</template>

<script>
export default {
  name: 'MdiArrowUpBold'
}
</script>